import { axios } from '@/utils/request'

const api = {
    partnerGroupList: '/adminapi/partner/groupList',
    partnerGroupAdd: '/adminapi/partner/groupAdd',
    partnerGroupEdit: '/adminapi/partner/groupEdit',
    partnerGroupDelete: '/adminapi/partner/groupDelete',
    partnerGroupDetail: '/adminapi/partner/groupDetail',


    partnerList: '/adminapi/partner/partnerList',
    getPartnerUserList: '/adminapi/partner/getPartnerUserList',
    addPartnerUser: '/adminapi/partner/addPartnerUser',
    deletePartnerUser: '/adminapi/partner/deletePartnerUser',
    getSubWyhList: '/adminapi/partner/getSubWyhList',

}

export default api

export function getPartnerList(parameter) {
    return axios({
        url: api.partnerList,
        method: 'get',
        params: parameter
    })
}
export function getPartnerUserList(parameter) {
    return axios({
        url: api.getPartnerUserList,
        method: 'post',
        data: parameter
    })
}
export function deletePartnerUser(parameter) {
    return axios({
        url: api.deletePartnerUser,
        method: 'post',
        data: parameter
    })
}
export function addPartnerUser(parameter) {
    return axios({
        url: api.addPartnerUser,
        method: 'post',
        data: parameter
    })
}
export function getSubWyhList(parameter) {
    return axios({
        url: api.getSubWyhList,
        method: 'post',
        data: parameter
    })
}

export function getPartnerGroupList(parameter) {
    return axios({
        url: api.partnerGroupList,
        method: 'get',
        params: parameter
    })
}
export function getPartnerGroupDetail(parameter) {
    return axios({
        url: api.partnerGroupDetail,
        method: 'get',
        params: parameter
    })
}
export function editPartnerGroup(parameter) {
    return axios({
        url: api.partnerGroupEdit,
        method: 'post',
        data: parameter
    })
}


export function addPartnerGroup(parameter) {
    return axios({
        url: api.partnerGroupAdd,
        method: 'post',
        data: parameter
    })
}
export function deletePartnerGroup(parameter) {
    return axios({
        url: api.partnerGroupDelete,
        method: 'post',
        data: parameter
    })
}